import PropTypes from 'prop-types';
import React, { Component } from "react";

import _ from 'lodash';
import Popover from 'src/core/gd-components/gd-popover/popover';
import Classes from 'classnames';

// THIS IS DEPRICATED !!! OLD !!!!

const propTypes = {

    value: PropTypes.any,                                        // current value
    options: PropTypes.array.isRequired,                            // array of options lable, value


    disabled: PropTypes.bool,
    placeholder: PropTypes.string,

    // underline
    underlined: PropTypes.oneOf(['on-hover', 'always', 'never']),  // if set will show border bottom for the value

    // look and feel
    renderValue: PropTypes.oneOf(['text-13', 'text-12', 'func']).isRequired, // render value view name
    renderValueFunc: PropTypes.func,        // func for external render function if passwed used to render instead of default

    // Callbacks
    onChange: PropTypes.func,                                       // on date selected -> returns moment
    onTogglePopover: PropTypes.func,

    // Popover options - tether usage: http://github.hubspot.com/tether/
    popoverAttachment: PropTypes.string,
    popoverTargetAttachment: PropTypes.string,
    popoverTargetOffset: PropTypes.string,

    tetherConstraints: PropTypes.array,
    attachmentType: PropTypes.oneOf(['full', 'vertical', 'horizontal'])

};

const defaultProps = {

    underlined: 'on-hover',

    placeholder: 'Please select',

    popoverAttachment: 'top center',
    popoverTargetAttachment: 'bottom center',
    attachmentType: "horizontal"
};



class SelectText extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showPopover: false,
            value: props.value
        };
    }


    UNSAFE_componentWillReceiveProps( nextProps ) {
        this.setState({
            value: nextProps.value
        });
    }

    shouldComponentUpdate( nextProps, nextState ) {
        return !(_.isEqual(nextProps,this.props) && _.isEqual(nextState,this.state));
    }

    onClick(e) {
        e.stopPropagation();
        this.showPopover();
    }

    showPopover() {
        const { onTogglePopover } = this.props;
        this.setState({showPopover: true},
            ()=>{if (onTogglePopover) onTogglePopover(true);});
    }

    hidePopover() {
        const { onTogglePopover } = this.props;
        this.setState({showPopover: false},
            ()=>{if (onTogglePopover) onTogglePopover(false);});
    }

    onOptionClick(value) {

        this.setState( {
            value: value,
            showPopover: false
        }, ()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(false);
            if (this.props.onChange) this.props.onChange(this.state.value);
        });

    }


    renderPopover() {

        if (!this.state.showPopover) return false;

        const { popoverAttachment, popoverTargetAttachment, popoverTargetOffset,
            tetherConstraints, attachmentType } = this.props;

        const content = (

            <div className="gd-popup-menu-items">

                {this.props.options.map((item, key)=>{
                    if (!!item.notSelectable) return;

                    const optionClass = Classes("action", {
                        'selected': item.value === this.state.value,
                        'disabled': (!!item.disabled)
                    });

                    const onClick = (!item.disabled)?this.onOptionClick.bind(this,item.value):undefined;


                    return (
                        <div className={optionClass} onClick={onClick} key={key} >
                            {item.label}
                        </div>
                    );

                })}


            </div>
        );

        return (
            <Popover popoverClass="gd-popover-menu"
                     targetClass={"pop-target"}
                     attachment={popoverAttachment}
                     targetAttachment={popoverTargetAttachment}
                     targetOffset={popoverTargetOffset}
                     attachmentType={attachmentType}
                     constraints={tetherConstraints}
                     onClickOutside={()=>{this.hidePopover()}} >

                {content}

            </Popover>
        );


    }

    renderValue() {

        const value = this.state.value;

        let curValueClasses;
        let curSelectedItem = null;

        if (value) {
            curSelectedItem = _.find(this.props.options, (option)=>{return option.value==value});
        }

        const curValueLabel = (curSelectedItem)?curSelectedItem.label:this.props.placeholder;

        switch (this.props.renderValue) {

            case 'text-13':
                curValueClasses = Classes('cur-value', 'pop-target','text-13', 'underlined-'+this.props.underlined);
                return (
                    <div className={curValueClasses}>{curValueLabel}</div>
                );

            case 'text-12':
                curValueClasses = Classes('cur-value', 'pop-target','text-12', 'underlined-'+this.props.underlined);
                return (
                    <div className={curValueClasses}>{curValueLabel}</div>
                );

            case 'func':
                return this.props.renderValueFunc(curSelectedItem);

        }


    }

    render() {

        const { disabled } = this.props;

        const classes = Classes('gd-select-text', this.props.className, {
            disabled: disabled,
            empty: !this.state.value
        });

        return (
            <div className={classes} onClick={disabled ? undefined : this.onClick.bind(this)}>
                {this.renderValue()}
                {this.renderPopover()}
            </div>
        );
    }


}



SelectText.propTypes = propTypes;
SelectText.defaultProps = defaultProps;

module.exports = SelectText;
